// extracted by mini-css-extract-plugin
var _1 = "BZeWz";
export { _1 as "view" }
